import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import t from "../translations";
import ShowError from "./ShowError";

function GenericErrorBoundary() {
    const error = useRouteError() as Error;

    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return <ShowError error={t("shared.error.generic-error")} />;
}

export default GenericErrorBoundary;
